import { useState, useEffect } from 'react';
import {
  isProtectedState,
  isProtectedCountry,
} from '@peloton/next/components/consentHelpers';
import { useFidesGeolocation } from '@ecomm/geolocation/hooks/useGeolocation';

const useGetGeoFooterData = () => {
  const [state, setState] = useState<string | undefined>(undefined);
  const [isDoNotSellEnabled, setIsDoNotSellEnabled] = useState<boolean | undefined>(
    undefined,
  );

  const { geolocation } = useFidesGeolocation();

  useEffect(() => {
    if (geolocation && !state) {
      setState(geolocation.region);
      if (
        (isProtectedState(geolocation.region) ||
          isProtectedCountry(geolocation.country)) &&
        isDoNotSellEnabled === undefined
      ) {
        setIsDoNotSellEnabled(true);
      }
    }
  }, [geolocation, isDoNotSellEnabled, state]);

  return { state, isDoNotSellEnabled };
};

export default useGetGeoFooterData;
